import Icon from '../components/Icon.vue'

Icon.register({
  'globe-americas': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM330.3 365.6c7.6-7.5 13.7-22.3 13.7-33v0c0-7-4-16.6-8.9-21.6l-13.7-13.7c-6-6-14.1-9.4-22.6-9.4h-66.8c-9.4-4.7-21.5-32-32-32-10.5 0-20.9-2.5-30.3-7.2l-11.1-5.5c-4-2-6.6-6.2-6.6-10.7v0c0-4.8 3.7-9.8 8.2-11.3l31.2-10.4c1.4-0.5 3.6-0.8 5.1-0.8 3.3 0 8 1.8 10.5 3.9l9.3 8.1c1.5 1.3 3.3 2 5.2 2h5.6c5.9 0 9.8-6.3 7.2-11.6l-15.6-31.2c-0.5-0.9-0.8-2.5-0.8-3.6 0-1.9 1.1-4.4 2.4-5.7l9.9-9.7c1.5-1.5 3.5-2.3 5.6-2.3h9 0c1.8 0 4.4-1 5.7-2.3l8-8c3.1-3.1 3.1-8.2 0-11.3l-4.7-4.7c-3.1-3.1-3.1-8.2 0-11.3l10.3-10.3 4.7-4.7c6.3-6.3 6.3-16.4 0-22.6l-28.3-28.3c-8.3 0.3-16.4 1.1-24.4 2.4v11.3c0 11.9-12.5 19.6-23.2 14.3l-24-12c-45.8 19.8-82.7 56.4-103.2 101.9 9.9 14.7 25.2 37.4 34.6 51.1 4.3 6.3 12.4 15.6 18.1 20.7l0.8 0.7c9.5 8.6 20.2 16 31.7 21.8 14 7 34.4 18.2 48.8 26.1 10.2 5.6 16.5 16.3 16.5 28v32c0 8.5 3.4 16.6 9.4 22.6 15 15 24.3 38.6 22.6 51.3v27.4c14.7 0 28.9-1.7 42.7-4.7l17.4-46.8c2-5.5 3.3-11.2 4.8-16.9 1.1-4 3.2-7.7 6.2-10.7 3.3-3.3 7.4-7.4 11.3-11.3zM417 274.3l29.2 7.3c1.1-8.4 1.8-16.9 1.8-25.5 0-32.1-7.8-62.4-21.3-89.3l-13 6.5c-3.7 1.9-6.9 4.7-9.2 8.1l-19.6 29.4c-2.2 3.3-4 9.3-4 13.3s1.8 10 4 13.3l18 27c3.3 5 8.4 8.5 14.2 10z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/globe-americas.js
// module id = 1392
// module chunks = 0